import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes, { oneOf } from 'prop-types';
import setClass from '../../common/set-class';
const Modal = (props) => {
    const { className, style, children, size } = props;
    useEffect(() => {
        document.body.classList.add('kb-modal-open');
        return () => {
            document.body.classList.remove('kb-modal-open');
        };
    }, []);
    return ReactDOM.createPortal(React.createElement("div", { tabIndex: -1, className: setClass(`kb-modal-${size}`, className), style: style }, children), document.body);
};
Modal.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    children: PropTypes.node,
    size: oneOf(['lg']),
};
Modal.defaultProps = {
    className: '',
    style: {},
    children: React.createElement(React.Fragment, null),
    size: 'lg',
};
export default Modal;
